export enum ScenarioState {
  CREATED = 'created',
  SUBMITTED = 'submitted',
  FAILED = 'failed',
  COMPLETED = 'completed',
  SCENARIO_RESULT_SENT = 'scenarioResultSent',
}
